import { get, map } from 'lodash';

export const mapOrderItemToAnalyticsFormat = orderItem => {
  const drinkChoices = map(orderItem.drinks, choice => choice.option.name);
  const sideChoices = map(orderItem.sides, choice => choice.option.name);

  return {
    product_id: get(orderItem, 'product.plu'),
    name: get(orderItem, 'product.name'),
    price: Number(get(orderItem, 'totals.dollarValue')) || 0,
    quantity: orderItem.quantity,
    category: get(orderItem.product, 'productCategory.name'),
    drinkChoices,
    sideChoices,
  };
};
